import React, { useCallback, useContext, useEffect } from 'react';
import { ReactReduxContext } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Breadcrumb from '@prisjakt/ui-breadcrumb';
import { AppContext } from '@prisjakt/ui-app-context';

import { PageHeader, PageContent } from 'src/components/page';

import { CreateAlert } from './components/create-alert';

import { CategoryPath, ProductAlertPageQuery } from '../../types';

import * as S from './styles';
import {
  trackInternalNavigationClick,
  InternalNavigationScope,
} from 'src/globals/tracking/tracking';

export type Props = {
  data: ProductAlertPageQuery;
};

const ProductAlert = ({ data }: Props) => {
  const { product, infoPage } = data;

  const { t } = useContext(AppContext);
  const { store } = useContext(ReactReduxContext);
  const history = useHistory();

  useEffect(() => {
    store.dispatch({
      type: 'ADS_VIEW_UPDATE',
      view: 'productAlert:mounted',
    });
  }, [store]);

  const onAlertAction = useCallback(() => {
    if (product?.pathName) {
      history.push(product.pathName);
    }
  }, [history, product]);

  const currentCategoryPath: CategoryPath = {
    id: product?.id?.toString() ?? '',
    name: product?.name ?? '',
    pathName: product?.pathName ?? '',
  };

  return (
    <S.ProductAlert>
      <PageContent withAds bottomPlacements={[]}>
        <Breadcrumb
          homeText={t('common', 'breadcrumb.home')}
          path={
            (product?.category?.path ?? []).concat(
              currentCategoryPath
            ) as CategoryPath[]
          }
          firstPathSelectable
          onClick={(nextPage: string) =>
            trackInternalNavigationClick({
              scope: InternalNavigationScope.BREADCRUMB,
              nextPage,
            })
          }
        />
        <PageHeader title={t('product', 'alert.title')}>
          <p>{t('product', 'alert.lead-text')}</p>
        </PageHeader>
        <S.MainArea>
          <S.CreateAlertWrapper>
            <CreateAlert
              productAlertFormData={data}
              privacyPolicyUri={infoPage?.pathName ?? undefined}
              onCreate={onAlertAction}
            />
          </S.CreateAlertWrapper>
        </S.MainArea>
      </PageContent>
    </S.ProductAlert>
  );
};

export default ProductAlert;
